import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getHomeReviewableMeals = async () => {
  const response = await fetchWrapper(hcUrl('/home/reviewable_meals'), buildOpts());
  return handleResponse(response);
};
